import React, { Suspense } from "react";

import { useAuth } from "@/contexts/auth/useAuth";
import LinkFooter from "@/features/ui/components/link-footer";
import {
  CtaBanner,
  LiveTvPanel,
  SignUpPanel,
  SuggestedGroupsPanel,
  TrendsPanel,
  TruthPlusPanel,
} from "@/features/ui/util/async-components";

import { Layout } from "../components/ui";

interface SearchPageProps {
  children: React.ReactNode;
}

const SearchPage: React.FC<SearchPageProps> = ({ children }) => {
  const { currentAccount } = useAuth();

  return (
    <>
      <Layout.Main>
        {children}

        {!currentAccount && (
          <Suspense fallback={null}>
            <CtaBanner key="cta-banner" />
          </Suspense>
        )}
      </Layout.Main>

      <Layout.Aside>
        {!currentAccount && (
          <Suspense fallback={null}>
            <SignUpPanel key="sign-up-panel" />
          </Suspense>
        )}

        <Suspense fallback={null}>
          <TruthPlusPanel key="truth-plus-panel" />
        </Suspense>

        <Suspense fallback={null}>
          <LiveTvPanel key="live-tv-panel" />
        </Suspense>

        <Suspense fallback={null}>
          <TrendsPanel limit={3} key="trends-panel" />
        </Suspense>

        <Suspense fallback={null}>
          <SuggestedGroupsPanel key="suggested-groups-panel" />
        </Suspense>

        <LinkFooter key="link-footer" />
      </Layout.Aside>
    </>
  );
};

export default SearchPage;
